export function convertToFlatSubItemList(mainItem: ILineItem): ISubItem[] {
  const items: ISubItem[] = []

  function iterateSubItems(mainItem: ILineItem) {
    if (mainItem.subItems?.length) {
      for (const subItem of mainItem.subItems) {
        items.push(subItem)
        iterateSubItems(subItem)
      }
    }
  }

  iterateSubItems(mainItem)

  return items
}
